class LegacyBundleSelect {
    constructor() {
        this.header = document.querySelector("body > header"), this.overlay = document.querySelector(".js-bundle-select-options-overlay"), this.overlay != null && (this.closeBtn = this.overlay.querySelector("[data-close-button]"), this.genderFiltersWrapper = this.overlay.querySelector("[data-gender-filters]"), this.genderFilters = this.genderFiltersWrapper.querySelectorAll("[data-gender-filter]"), this.newFilterBtn = this.genderFiltersWrapper.querySelector('[data-new-filter="true"]'), this.isNewActive = !1, this.fragranceWrappers = this.overlay.querySelectorAll("[data-fragrance-wrapper]"), this.submitButtonWrapper = this.overlay.querySelector("[data-submit-button]"), this.selectFields = document.querySelectorAll(".js-bundle-select"), this.searchField = this.overlay.querySelector("[data-search-field]"), this.searchButton = this.overlay.querySelector("[data-search-button]"), this.clearSearch = this.overlay.querySelector("[data-clear-search]"), this.selectBoxButtons = document.querySelectorAll("[data-search-box-replacement]"), this.productLimit = 4, this.selectedProducts = [], this.initEventListeners())
    }
    initEventListeners() {
        this.selectBoxButtons.forEach(select => {
            ["click"].forEach(eventType => {
                select.addEventListener(eventType, e => {
                    e.preventDefault(), e.stopPropagation(), this.toggleOverlay(select, e)
                })
            })
        }), this.selectFields.forEach(select => {
            select.parentElement.querySelector(".js-bundle-select-search-icon").classList.remove("hidden"), ["click"].forEach(eventType => {
                select.addEventListener(eventType, e => {
                    e.preventDefault(), e.stopPropagation(), this.toggleOverlay(select, e)
                })
            })
        }), this.closeBtn.addEventListener("click", e => {
            this.toggleOverlay()
        }), this.genderFilters.forEach(filter => {
            filter.addEventListener("click", e => {
                this.toggleGenderFilter(filter)
            })
        }),
        
        this.newFilterBtn && this.newFilterBtn.addEventListener("click", e => {
        e.preventDefault(), this.toggleNewFilter(this.newFilterBtn)
        }), this.fragranceWrappers.forEach(fragranceWrapper => {
            fragranceWrapper.querySelector("button[data-quantity-add").addEventListener("click", e => {
                e.preventDefault(), e.target.parentElement.querySelector("input").value++, this.updateSelectedProducts()
            }), fragranceWrapper.querySelector("button[data-quantity-remove").addEventListener("click", e => {
                e.preventDefault(), e.target.parentElement.querySelector("input").value--, this.updateSelectedProducts()
            }), fragranceWrapper.querySelector('input[type="checkbox"]').addEventListener("click", e => {
                this.updateSelectedProducts()
            })
        }), this.submitButtonWrapper.querySelector("button").addEventListener("click", e => {
            e.preventDefault(), this.updateSelectOptions()
        }), this.searchField.addEventListener("keyup", e => {
            e.preventDefault(), this.search()
        }), this.searchField.addEventListener("input", e => {
            e.target.value.length === 0 && this.search()
        }), this.clearSearch.addEventListener("click", e => {
            e.preventDefault(), this.searchField.value = "", this.searchField.focus(), this.search()
        }), this.genderFilters[0].click();

        // Initial lock on page load
        this.updateMainAtcState();

        // Update lock when selects change
        this.selectFields.forEach((sel) => {
            sel.addEventListener('change', () => this.updateMainAtcState());
        });

    }
    updateSelectOptions() {
        this.selectFields.forEach((select, i) => {
            if (this.selectedProducts[i] !== void 0) {
                let selectedOption = this.selectedProducts[i].querySelector('input[type="checkbox"]').value;
                select.querySelectorAll("option").forEach(option => {
                    option.value === selectedOption ? option.selected = !0 : option.selected = !1
                });
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            this.selectBoxButtons[i].querySelector("[data-selected-product]").innerText = this.selectedProducts[i].querySelector('input[type="checkbox"]').value
        }), document.querySelector(".atc-button").click(), this.toggleOverlay(), this.updateMainAtcState();
    }
    updateSelectedProducts() {
        this.selectedProducts = [], this.fragranceWrappers.forEach(fragranceWrapper => {
            const checkbox = fragranceWrapper.querySelector('input[type="checkbox"]');
            let quantity = checkbox.parentElement.querySelector("[data-quantity-selector]").querySelector("input").value;
            if (checkbox.checked && quantity > 0) {
                checkbox.classList.add("hidden"), checkbox.parentElement.querySelector("[data-quantity-selector]").classList.remove("hidden"), fragranceWrapper.classList.remove("border-white"), fragranceWrapper.classList.add("border-[#4d8127]"), console.log("QUANTITY: ", quantity);
                for (let i = 0; i < quantity; i++) this.selectedProducts.push(fragranceWrapper)
            } else fragranceWrapper.classList.add("border-white"), fragranceWrapper.classList.remove("border-[#4d8127]"), checkbox.checked = !1, checkbox.classList.remove("hidden"), checkbox.parentElement.querySelector("[data-quantity-selector]").classList.add("hidden"), checkbox.parentElement.querySelector("[data-quantity-selector]").querySelector("input").value = 1
        }), this.submitButtonWrapper.querySelector("[data-total-selected]").innerHTML = this.selectedProducts.length, this.selectedProducts.length === this.productLimit ? (this.overlay.querySelector("[data-discount-notification]").classList.remove("hidden"), this.fragranceWrappers.forEach(fragranceWrapper => {
            fragranceWrapper.querySelector('input[type="checkbox"]').checked || fragranceWrapper.classList.add("opacity-30", "pointer-events-none"), fragranceWrapper.querySelector("button[data-quantity-add").classList.add("hidden")
        }), this.submitButtonWrapper.querySelector("button").disabled = !1, this.submitButtonWrapper.querySelector("[data-submit-label]").classList.remove("hidden"), this.submitButtonWrapper.querySelector("[data-submit-counter]").classList.add("hidden")) : (this.fragranceWrappers.forEach(fragranceWrapper => {
            fragranceWrapper.querySelector("button[data-quantity-add").classList.remove("hidden"), fragranceWrapper.classList.remove("opacity-30", "pointer-events-none")
        }), this.selectBoxButtons.forEach(button => {
            button.classList.remove("hidden")
        }), this.submitButtonWrapper.querySelector("button").disabled = !0, this.submitButtonWrapper.querySelector("[data-submit-label]").classList.add("hidden"), this.selectedProducts.length == 0 ? (this.submitButtonWrapper.querySelector("[data-initial-prompt]").classList.remove("hidden"), this.submitButtonWrapper.querySelector("[data-submit-counter]").classList.add("hidden")) : (this.submitButtonWrapper.querySelector("[data-initial-prompt]").classList.add("hidden"), this.submitButtonWrapper.querySelector("[data-submit-counter]").classList.remove("hidden")), this.overlay.querySelector("[data-discount-notification]").classList.add("hidden"));
        this.updateMainAtcState();

    }
    toggleOverlay() {
        document.querySelector("body").classList.toggle("overflow-hidden"), console.log(this), this.overlay.classList.toggle("hidden")
    }
    toggleGenderFilter(filter) {
        this.genderFilters.forEach(genderFilter => {
            genderFilter.classList.remove("border-b-black", "text-black"), genderFilter.classList.add("border-b-gray-200")
        }), filter.classList.remove("border-b-gray-200"), filter.classList.add("border-b-black", "text-black");

        // Turn OFF Nieuw mode when user clicks a gender tab
        this.isNewActive = !1;
        this.newFilterBtn && (this.newFilterBtn.classList.remove("border-b-black", "text-black"), this.newFilterBtn.classList.add("border-b-gray-200"));


        const selectedGender = filter.dataset.genderFilter.toLowerCase();
        this.fragranceWrappers.forEach(fragranceWrapper => {
        const genderOk =
            fragranceWrapper.dataset.gender.toLowerCase().split(",").map(gender => gender.trim()).includes(selectedGender) || selectedGender === "all";

            const isNew = (fragranceWrapper.dataset.isNew || "false").toLowerCase() === "true";
            const newOk = !this.isNewActive || isNew;

            genderOk && newOk ? fragranceWrapper.classList.remove("hidden") : fragranceWrapper.classList.add("hidden")
        })

    }
    toggleNewFilter(filter) {
        // When clicking Nieuw, make it the only active tab (like a real tab)
        this.genderFilters.forEach(genderFilter => {
            genderFilter.classList.remove("border-b-black", "text-black");
            genderFilter.classList.add("border-b-gray-200");
        });

        // Activate Nieuw tab UI
        filter.classList.remove("border-b-gray-200");
        filter.classList.add("border-b-black", "text-black");

        // Nieuw mode ON (not toggle)
        this.isNewActive = !0;

        // Show only new items (gender = all)
        this.fragranceWrappers.forEach(fragranceWrapper => {
            const isNew = (fragranceWrapper.dataset.isNew || "false").toLowerCase() === "true";
            isNew ? fragranceWrapper.classList.remove("hidden") : fragranceWrapper.classList.add("hidden");
        })
    }


    search() {
        let searchValue = this.searchField.value.toLowerCase();
        if (document.querySelector("[data-no-results]").classList.add("hidden"), searchValue.length === 0) {
            this.fragranceWrappers.forEach(fragranceWrapper => {
                fragranceWrapper.classList.remove("hidden")
            }), this.genderFiltersWrapper.classList.remove("hidden");
            return
        }
        this.genderFiltersWrapper.classList.add("hidden");
        let hiddenWrappers = 0;
        this.fragranceWrappers.forEach(fragranceWrapper => {
            fragranceWrapper.dataset.fragrance.toLowerCase().includes(searchValue) ? fragranceWrapper.classList.remove("hidden") : (fragranceWrapper.classList.add("hidden"), hiddenWrappers++)
        }), console.log(hiddenWrappers, this.fragranceWrappers.length), hiddenWrappers == this.fragranceWrappers.length && document.querySelector("[data-no-results]").classList.remove("hidden")
    }
    /* =========================
        ATC lock/unlock (bundle gate)
        Enables theme ATC only when 3 selects are chosen (Option 1/2/3 != "")
        ========================= */

        getBundleRoot() {
            // Your selects are inside .main-proc (product-bundles.liquid)
            return this.overlay?.closest('.main-proc') || document.querySelector('.main-proc') || document;
        }

        getMainAtcButton() {
            // In your theme: <button name="add" class="... atc-button ...">
            const root = this.getBundleRoot();
            const pf = root.closest('product-form') || document.querySelector('product-form');
            return (
                (pf && pf.querySelector('button[name="add"].atc-button')) ||
                (pf && pf.querySelector('button[name="add"]')) ||
                document.querySelector('button[name="add"].atc-button') ||
                document.querySelector('button[name="add"]')
            );
        }

        are3SelectsChosen() {
            const root = this.getBundleRoot();
            const selects = root.querySelectorAll('select.js-bundle-select[required]');
            if (!selects || selects.length < 4) return false;

            return Array.from(selects)
                .slice(0, 4)
                .every((s) => (s.value || '').trim() !== ''); // works with your placeholder value=""
        }

        updateMainAtcState() {
            const atc = this.getMainAtcButton();
            if (!atc) return;

            const ok = this.are3SelectsChosen();

            if (!ok) {
                // lock
                atc.dataset.bundleLocked = '1';
                atc.disabled = true;
                atc.setAttribute('disabled', 'disabled');
                atc.setAttribute('aria-disabled', 'true');

                // optional label
                const span = atc.querySelector('span');
                if (span) span.textContent = 'Kies 4 geuren';
            } else {
                // unlock only if WE locked it
                if (atc.dataset.bundleLocked !== '1') return;

                atc.disabled = false;
                atc.removeAttribute('disabled');
                atc.removeAttribute('aria-disabled');
                atc.classList.remove('loading');

                delete atc.dataset.bundleLocked;

                // restore label (best effort)
                const span = atc.querySelector('span');
                if (span && window.variantStrings?.addToCart) {
                span.textContent = window.variantStrings.addToCart;
                }
            }
        }

}
window.Alpine = Alpine, Alpine.start(), document.addEventListener("DOMContentLoaded", () => {
    new LegacyBundleSelect
}), document.querySelectorAll("body.collection-mixology .max-w-prose.w-full a.btn").forEach(btn => {
    btn.addEventListener("click", function(e) {
        e.preventDefault(), window._klOnsite = window._klOnsite || [], window._klOnsite.push(["openForm", "QQdBFQ"])
    })
});
const urlParams = new URLSearchParams(window.location.search);
urlParams.get("utm_source");